var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_time-alarm",
    clipPath: "url(#clip0_4_15565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 7.08334V11.25H14.1667",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99996 18.3333C13.912 18.3333 17.0833 15.162 17.0833 11.25C17.0833 7.33799 13.912 4.16667 9.99996 4.16667C6.08794 4.16667 2.91663 7.33799 2.91663 11.25C2.91663 15.162 6.08794 18.3333 9.99996 18.3333Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.99996 16.25L2.91663 18.3333",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15 16.25L17.0833 18.3333",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.29587 1.94041C6.49475 1.41228 5.5359 1.17685 4.58127 1.27386C3.62665 1.37088 2.73477 1.7944 2.05627 2.4729C1.37777 3.15139 0.95425 4.04328 0.857235 4.9979C0.760219 5.95252 0.995659 6.91137 1.52379 7.7125L7.29587 1.94041Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7042 1.94041C13.5053 1.41228 14.4642 1.17685 15.4188 1.27386C16.3734 1.37088 17.2653 1.7944 17.9438 2.4729C18.6223 3.15139 19.0458 4.04328 19.1429 4.9979C19.2399 5.95252 19.0044 6.91137 18.4763 7.7125L12.7042 1.94041Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.34266,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_15565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClook);
export default __webpack_public_path__ + "static/media/IconClook.4e6daf6a2be5c40edf4513e7931ceeff.svg";
export { ForwardRef as ReactComponent };